import { Component } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationCancel } from '@angular/router';
import { from, Observable } from 'rxjs';
import { UserManagementService } from '../shared/services/user-management.service';
import { AuthService } from '../shared/services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  hasTargetColumnMapping: boolean | null = null;
  orgId: string = '';
  isLoaded = false;
  selectedTabIndex = 0;
  currentIndex: number = 0;
  isNflAdmin: boolean = false;

  tabs = [
    { name: 'File Upload', value: 'upload' },
    { name: 'Upload History', value: 'history' },
  ];

  constructor(
    private userManagement: UserManagementService,
    private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.hasTargetColumnMapping = this.authService.hasTargetColumnMappingEmpty(this.userManagement.getOrgId());
    this.isNflAdmin = this.userManagement.isNflAdmin();
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        const current = this.activatedRoute.firstChild?.snapshot.url[0]?.path;
        const index = this.getTabIndexForRoute(current ?? 'upload');
        this.currentIndex = this.getTabIndexForRoute(current ?? 'upload');
        this.selectedTabIndex = index;
      }
    });

    const initial = this.activatedRoute.firstChild?.snapshot.url[0]?.path;
    if (initial) {
      this.router.navigate([initial], { relativeTo: this.activatedRoute });
    }
  }

  private getTabIndexForRoute(routePath: string): number {
    return this.tabs?.findIndex((tab) => tab.value === routePath) || 0;
  }

  navigateToTab(index: number): void {
    const targetRoute = this.tabs[index].value;

    this.router
      .navigate([targetRoute], {
        relativeTo: this.activatedRoute,
      })
      .then((success) => {
        if (success) {
          this.currentIndex = index;
          this.selectedTabIndex = index;
        } else {
          this.selectedTabIndex = this.currentIndex;
        }
      });
  }

  canDeactivateTab = (fromIndex: number, toIndex: number): Observable<boolean> => {
    const targetRoute = this.tabs[toIndex].value;

    return from(
      this.router.navigate([targetRoute], {
        relativeTo: this.activatedRoute,
      }),
    );
  };
}
